import React, { useMemo } from 'react';
import { styled } from "@mui/material/styles";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'Tour'

const classes = {
  root: `${PREFIX}-root`,
  boldText: `${PREFIX}-boldText`,
  textContainer: `${PREFIX}-textContainer`,
  typographyStyle: `${PREFIX}-typographyStyle`
}

const TourContainer = styled('div')((
  {
    theme
  }
) => {
  return {
    [`& .${classes.root}`]: {
      width: '100%',
      minWidth: '140px',
      height: '100%',
      textAlign: 'center',
    },
    [`& .${classes.typographyStyle}`]: {
      color: "rgba(255, 255, 255, 0.9)",
    },
    [`& .${classes.textContainer}`]: {
      borderRadius: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    [`& .${classes.boldText}`]: {
      fontWeight: '800',
    },
  }
})

const useSteps = () => {
  const { t, i18n } = useTranslation();
  const width = useMemo(() => window.innerWidth, [window.innerWidth]);
  const height = useMemo(() => window.innerHeight, [window.innerHeight]);
  const locale = i18n.language;


  const sizes = {
    step0: {
      fr: 190,
      en: 190,
      height: {
        fr: 184,
        en: 184,
      }
    },
    step1: {
      fr: 196,
      en: 219,
    },
    step2: {
      fr: 192,
      en: 190,
    },
    step3: {
      fr: 190,
      en: 190,
    },
    step4: {
      fr: 190,
      en: 190,
    }
  }

  const steps = [
    {
      selector: '#n',
      content:
        <TourContainer>
          <div className={classes.root}>
            <div className={classes.textContainer}>
              <Typography variant='body1' className={classes.typographyStyle}>
                <div className={classes.boldText}>
                  {t('tutorial.webXr.step0.boldText')}
                </div>
                <div>
                  {t('tutorial.webXr.step0.firstLineRest')}
                </div>
                <div>
                  {t('tutorial.webXr.step0.text')}
                </div>
                {t('tutorial.webXr.step0.end')}
              </Typography>
            </div>
          </div>
        </TourContainer>,
      position: [(width / 2) - (sizes.step0[locale] / 2), (height / 2) - (sizes.step0.height[locale] / 2)],
    },
    {
      selector: '#mobileStepper',
      content:
        <TourContainer>
          <div className={classes.root}>
            <div className={classes.textContainer}>
              <Typography variant='body1' className={classes.typographyStyle}>
                <div className={classes.boldText}>
                  {t('tutorial.webXr.step1.boldText')}
                </div>
                {t('tutorial.webXr.step1.text')}
              </Typography>
            </div>
          </div>
        </TourContainer>,
      position: [(width / 2) - (sizes.step1[locale] / 2), height - 200],
    },
    {
      selector: '#fakeArButton',
      content: <TourContainer>
        <div className={classes.root}>
          <div className={classes.textContainer}>
            <Typography variant='body1' className={classes.typographyStyle}>
              <div>
                <span className={classes.boldText}>
                  {t('tutorial.webXr.step2.boldText')}
                </span>
                <span> {t('tutorial.webXr.step2.firstLineRest')}</span>
              </div>
              {t('tutorial.webXr.step2.text')}
            </Typography>
          </div>
        </div>
      </TourContainer>,
      position: [(width / 2) - (sizes.step2[locale] / 2), height - 270]
    },
    {
      selector: '#enterTheMetaverse',
      content: <TourContainer>
        <div className={classes.root}>
          <div className={classes.textContainer}>
            <Typography variant='body1' className={classes.typographyStyle}>
              <div>
                <span className={classes.boldText}>
                  {t('tutorial.webXr.step3.boldText')}
                </span>
              </div>
              <div>
                {t('tutorial.webXr.step3.firstLineRest')}
              </div>
              {t('tutorial.webXr.step3.text')}
            </Typography>
          </div>
        </div>
      </TourContainer>,
      position: [(width / 2) - (sizes.step2[locale] / 2), 60]
    },
    {
      selector: '#redirectionsBar',
      content: <TourContainer>
        <div className={classes.root}>
          <div className={classes.textContainer}>
            <Typography variant='body1' className={classes.typographyStyle}>
              <div>
                <span className={classes.boldText}>
                  {t('tutorial.webXr.step4.boldText')}
                </span>
              </div>
              <div>
                {t('tutorial.webXr.step4.firstLineRest')}
              </div>
              {t('tutorial.webXr.step4.text')}
            </Typography>
          </div>
        </div>
      </TourContainer>,
      position: [(width / 2) - (sizes.step4[locale] / 2), height - 300]
    },
  ];

  return steps
}

export default useSteps
